/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Define_Permutation_Date_HourInputs */



/**
* | output |
* | --- |
* | "Define changeover date and time" |
*
* @param {Define_Permutation_Date_HourInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const define_permutation_date_hour = /** @type {((inputs?: Define_Permutation_Date_HourInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Define_Permutation_Date_HourInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Define changeover date and time")
	return /** @type {LocalizedString} */ ("Définir la date et l'heure de permutation")
});